import React, { useEffect } from 'react';
import Confetti from 'react-confetti';

const GiftModal = ({ gift, isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen && gift) {
      // Konfetti für Geschenke
    }
  }, [isOpen, gift]);

  if (!isOpen || !gift) return null;

  const getGiftTypeEmoji = (type) => {
    switch (type) {
      case 'round':
        return '🍺';
      case 'shot':
        return '🥃';
      case 'special':
        return '🎁';
      default:
        return '🍻';
    }
  };

  return (
    <>
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        recycle={false}
        numberOfPieces={300}
        gravity={0.3}
        colors={['#f39c12', '#e67e22', '#d35400', '#f1c40f']}
      />
      
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={e => e.stopPropagation()}>
          <div className="text-center">
            <div className="text-6xl mb-4">🎁</div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">
              {gift.giver_name} lädt euch ein!
            </h3>
            <div className="text-4xl mb-4">
              {getGiftTypeEmoji(gift.gift_type)}
            </div>
            <p className="text-gray-600 mb-4">
              {gift.message}
            </p>
            <button
              onClick={onClose}
              className="btn-primary w-full"
            >
              Danke! 🍻
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default GiftModal; 